var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup212(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 46,
    viewBox: "0 0 60 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5005,
    cy: 25.5,
    r: 20.5,
    fill: "black",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2005 9L10.0005 14.6V34.2C10.0005 34.9426 10.2955 35.6548 10.8206 36.1799C11.3457 36.705 12.0579 37 12.8005 37H32.4005C33.1431 37 33.8553 36.705 34.3804 36.1799C34.9055 35.6548 35.2005 34.9426 35.2005 34.2V14.6L31.0005 9H14.2005Z",
    stroke: "black",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2005 20.2C28.2005 21.6852 27.6105 23.1095 26.5603 24.1597C25.5101 25.21 24.0857 25.7999 22.6005 25.7999C21.1153 25.7999 19.6909 25.21 18.6407 24.1597C17.5905 23.1095 17.0005 21.6852 17.0005 20.2",
    stroke: "black",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 14.6H35.2005",
    stroke: "black",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup212);
export default __webpack_public_path__ + "static/media/Group 21 (2).b44d3cdccde9c76367d40efe933f53bb.svg";
export { ForwardRef as ReactComponent };